module.exports = __webpack_public_path__ + "static/img/background.fd3de31d.svg";